import ShiftCodeContainer from "../../containers/ShiftCodeContainer";
import ShiftCodeListContainer from "../../containers/ShiftCodeListContainer";
import ShiftMappingContainer from "../../containers/ShiftMappingContainer";
import ShiftMappingListContainer from "../../containers/ShiftMappingListContainer";

export class TimeAndAttendanceGenericConstants {
  static readonly Tabs = [
    {
      headerKey: "shiftDetails.label.shiftCodes",
      addLabelKey: "shiftDetails.label.addShiftCode",
      editLabelKey: "shiftDetails.label.editShiftCode",
      listComponent: ShiftCodeListContainer,
      sidebarComponent: ShiftCodeContainer,
    },
    {
      headerKey: "shiftDetails.label.shiftMapping",
      addLabelKey: "shiftDetails.label.addShiftMapping",
      editLabelKey: "shiftDetails.label.editShiftMapping",
      listComponent: ShiftMappingListContainer,
      sidebarComponent: ShiftMappingContainer,
    }
  ];
}
